import { render, staticRenderFns } from "./UpdateProfileView.vue?vue&type=template&id=36ec05cd"
import script from "./UpdateProfileView.vue?vue&type=script&lang=js"
export * from "./UpdateProfileView.vue?vue&type=script&lang=js"
import style0 from "./UpdateProfileView.vue?vue&type=style&index=0&id=36ec05cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports